<template>
  <div class="product">
<!--    <img class="product__wave" src="@images/storeTopWave.png" alt="wave">-->
    <div class="product__top">
      <div class="container">
        <div class="product__top-wrapper">
          <button class="product__button" @click="router.go(-1)">
            <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.53572 5.38596L6.24989 0.500372L7.42822 1.72155L3.30322 5.99655L7.42822 10.2716L6.24989 11.4927L1.53572 6.60714C1.3795 6.44519 1.29173 6.22556 1.29173 5.99655C1.29173 5.76755 1.3795 5.54792 1.53572 5.38596Z" fill="#2B3044"/>
            </svg>
            {{ t('buttons.otherProducts') }}
          </button>
          <el-breadcrumb separator=">">
            <el-breadcrumb-item :to="translations.i18nRoute({ name: 'home' })">{{ t('home.title') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ product ? product.name : 'Product' }}</el-breadcrumb-item>
<!--            <el-breadcrumb-item>{{ product ? product.name : 'Product' }}</el-breadcrumb-item>-->
          </el-breadcrumb>
          <div class="product__top-inner" v-if="product">
            <div class="product__top-left">
              <h1 class="product__top-title">{{ product.name }}</h1>
              <div class="product__top-block">
                <div>
                  <div class="product__top-item">
                    <img src="@icons/currency.svg" alt="currency">
                    {{ product.price }}
                  </div>
                  <div class="product__top-item">
<!--                    <img src="@icons/ratingIcon.svg" alt="rating">-->
<!--                    {{ product.feedbacks.length ? product.feedbacks.edges[0].node.rating : 5 }}-->
                    <el-rate
                        disabled
                        v-model="product.rating"
                    />
                  </div>
                </div>
                <div>
                  <div class="product__top-tag tag1">HTML</div>
                  <div class="product__top-tag tag2">CSS</div>
                  <div class="product__top-tag tag3">JS</div>
                </div>
              </div>
              <ui-button class="product__top-button" @click="overwriteCart">
                {{ isProductInCart ? t('buttons.removeFromCart') : t('buttons.addToCart') }}
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.35498 1.8797H1.64478C2.15645 1.8797 2.41273 1.8797 2.62142 1.97201C2.80542 2.0534 2.96273 2.18444 3.07617 2.3506C3.20463 2.53875 3.25101 2.79 3.3436 3.29151L5.67488 15.9193L16.93 15.9192C17.4194 15.9192 17.6649 15.9192 17.8677 15.8327C18.0467 15.7564 18.2012 15.6326 18.3159 15.4753C18.4456 15.2974 18.5006 15.0592 18.6104 14.5834L18.6112 14.58L20.3059 7.23628L20.3063 7.23474C20.4728 6.51291 20.5563 6.15112 20.4646 5.86734C20.3842 5.61834 20.2149 5.40723 19.9904 5.27286C19.7343 5.11959 19.3642 5.11959 18.6222 5.11959H4.05489M17.5544 21.319C16.958 21.319 16.4745 20.8355 16.4745 20.2391C16.4745 19.6426 16.958 19.1591 17.5544 19.1591C18.1509 19.1591 18.6344 19.6426 18.6344 20.2391C18.6344 20.8355 18.1509 21.319 17.5544 21.319ZM6.7548 21.319C6.15835 21.319 5.67483 20.8355 5.67483 20.2391C5.67483 19.6426 6.15835 19.1591 6.7548 19.1591C7.35125 19.1591 7.83476 19.6426 7.83476 20.2391C7.83476 20.8355 7.35125 21.319 6.7548 21.319Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </ui-button>
              <div class="product__top-desc">
                <h6>{{ t('product.description') }}</h6>
                <div v-if="product.description" v-html="product.description" />
              </div>
            </div>
            <div>
              <svg @click="overwriteWishlist" class="product__wishlist" width="51" viewBox="0 0 51 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_59_1210)">
                  <rect x="3.99976" y="0.00012207" width="43" height="32" rx="4" fill="white"/>
                </g>
                <path d="M31.8942 10.5209C33.2652 11.9043 33.3177 14.1304 32.0135 15.578L25.4785 22.8312L18.9443 15.578C17.6401 14.1304 17.6927 11.9043 19.0636 10.5209C20.5944 8.97621 23.1155 9.11736 24.4679 10.8232L25.4789 12.098L26.4891 10.823C27.8415 9.11721 30.3635 8.97626 31.8942 10.5209Z" :stroke="isProductInWishlist ? '#e33b23' : 'currentColor'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :fill="isProductInWishlist ? '#e33b23' : 'white'" />
              </svg>
              <img class="product__top-image" :src="product.images.edges[0].node.image" :alt="product.name">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product__like">
      <div class="container">
        <div class="product__like-wrapper">
          <h2 class="product__like-title">{{ t('cart.alsoLike') }}</h2>
        </div>
      </div>
      <div class="product__like-block">
<!--        <img class="product__like-bg" src="@images/productLikeBg.png" alt="bg">-->
        <swiper
            class="product__like-swiper"
            :modules="[Pagination]"
            :pagination="{
              clickable: true,
            }"
            :loop="true"
            :speed="500"
            :breakpoints="{
              200: {
                slidesPerView: 3,
              }
            }"
        >
          <swiper-slide
              class="product__like-swiper-slide"
              v-for="product in products"
              :key="product.node.uuid"
          >
            <product-card
                :product="product.node"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script setup>
import translations from "@/core/helpers/translations.js";
import {useI18n} from "vue-i18n";
import {computed, onMounted, ref, watch} from "vue";
import {Products} from "@/core/api/products.js";
import {useRoute, useRouter} from "vue-router";
import {Orders} from "@/core/api/orders.js";
import {ElNotification} from "element-plus";
import {Wishlist} from "@/core/api/wishlist.js";
import {useWishlistStore} from "@/stores/wishlist.js";
import {useCartStore} from "@/stores/cart.js";
import {useAuthStore} from "@/stores/auth.js";
import UiButton from "@/components/ui/ui-button.vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css/pagination';
import 'swiper/css';
import {Pagination} from "swiper/modules";
import ProductCard from "@/components/cards/product-card.vue";

const {t, locale} = useI18n()
const route = useRoute()
const router = useRouter()
const wishlistStore = useWishlistStore()
const cartStore = useCartStore()
const authStore = useAuthStore()

const productUuid = computed(() => {
  return route.params.productUuid
})

const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : ''
})
const orderUuid = computed(() => {
  return cartStore.currentOrder ? cartStore.currentOrder.uuid : null
})
const wishlistUuid = computed(() => {
  return wishlistStore.wishlist ? wishlistStore.wishlist.uuid : ''
})
const user = computed(() => {
  return authStore.user ? authStore.user : null
})

const product = ref(null)

const getProductById = async () => {
  const res = await Products.getProductById(productUuid.value)
  product.value = res.data.products.edges[0].node
}

const getProducts = async () => {
  const res = await Products.getProducts(`tags: "top"`)
  products.value = res.data.products.edges.slice(0, 6)
}

const isProductInCart = computed(() => {
  return cartStore.currentOrder?.orderProducts?.edges.find((prod) => prod.node.product.uuid === productUuid.value)
})
const isProductInWishlist = computed(() => {
  const el = wishlistStore.wishlist.products?.edges.find(
    (el) => el?.node?.uuid === productUuid.value
  );

  return !!el;
});

const overwriteCart = async () => {
  if (user.value) {
    if (isProductInCart.value) {
      const res = await Orders.overwriteCart("removeOrderProduct", accessToken.value, orderUuid.value, productUuid.value);

      cartStore.setCurrentOrders(res.data.removeOrderProduct.order)
    } else {
      const res = await Orders.overwriteCart("addOrderProduct", accessToken.value, orderUuid.value, productUuid.value);
      cartStore.setCurrentOrders(res.data.addOrderProduct.order)

      if (res.errors) {
        ElNotification({
          message: res.errors[0].message,
          type: "error"
        });
      } else {
        ElNotification({
          message: t('popup.addToCart', { product: product.value.name }),
          type: "success"
        });
      }
    }
  } else {
    await router.push({
      name: 'login',
      params: {
        locale: localStorage.getItem('fpt-user-locale') || 'en-gb'
      }
    })
  }
}

const overwriteWishlist = async () => {
  if (user.value) {
    if (isProductInWishlist.value) {
      const res = await Wishlist.overwriteWishlist('removeWishlistProduct', accessToken.value, wishlistUuid.value, productUuid.value)
      wishlistStore.wishlist = res.data.removeWishlistProduct.wishlist
    } else {
      const res = await Wishlist.overwriteWishlist('addWishlistProduct', accessToken.value, wishlistUuid.value, productUuid.value)
      wishlistStore.wishlist = res.data.addWishlistProduct.wishlist

      if (res.data.addWishlistProduct) {
        ElNotification({
          message: t('popup.addToWishlist', { product: product.value.name }),
          type: "success"
        });
      } else {
        ElNotification({
          message: res.errors[0].message,
          type: "error"
        });
      }
    }
  } else {
    await router.push({
      name: 'login',
      params: {
        locale: localStorage.getItem('fpt-user-locale') || 'en-gb'
      }
    })
  }
}

const products = ref([])

watch(
    () => locale.value,
    async () => {
      products.value = [];
      await getProducts()
    }
)

watch(
    () => productUuid.value,
    async () => {
      await getProductById()

      await getProducts()
    },
    { deep: true }
)

onMounted(async () => {
  await getProductById()

  await getProducts()
})
</script>

<style lang="scss" scoped>
.product {
  position: relative;

  &__wave {
    width: 100vw;
    position: absolute;
  }

  &__button {
    margin-bottom: 25px;
    border-radius: 10px;
    border: 1px solid #5B194F;
    background-color: $white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
    padding: 14px 7px;
    cursor: pointer;
    transition: 0.2s;

    color: #2B3044;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 500;
    
    &:hover {
      background-color: #ececec;
    }
  }

  &__top {
    position: relative;
    z-index: 1;
    padding-block: 75px 80px;

    &-inner {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 25px;

      & div {
        position: relative;
      }
    }

    &-left {
      display: flex;
      flex-direction: column;
      gap: 35px;
    }

    &-title {
      margin-top: 20px;
      text-transform: capitalize;
      font-family: Syne, sans-serif;
      font-size: 50px;
      font-weight: 700;
      background: linear-gradient(90deg, #FF85FD 0.5%, #7D045A 44.83%, #3D2B44 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &-image {
      border-radius: 28px;
      width: 574px;
      height: 348px;
      object-fit: cover;
    }

    &-block {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      & div {
        display: flex;
        align-items: center;
        gap: 10px;

        & img {
          width: 33px;
        }
      }
    }

    &-item {
      border-radius: 10px;
      border: 1px solid #5B194F;
      background-color: $white;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
      padding: 10px 15px;
      align-items: flex-end !important;

      color: #2B3044;
      font-size: 20px;
      font-weight: 500;
    }

    &-tag {
      border-radius: 4px;
      width: 50px;
      padding-block: 9px;
      justify-content: center;

      font-size: 11px;
      color: $white;
      font-weight: 500;
    }

    &-button {
      width: fit-content;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 20px;
    }

    &-desc {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 609px;

      & h6 {
        padding-bottom: 13px;
        border-bottom: 1px solid #5B194F;

        color: #213254;
        font-size: 22px;
        font-weight: 500;
      }

      & div {
        color: #696969;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }

  &__wishlist {
    position: absolute;
    top: 34px;
    right: 31px;
    cursor: pointer;
    transition: 0.2s;

    color: #2B3044;

    &:hover {
      color: $red;
    }
  }

  &__like {
    margin-top: 25px;

    &-wrapper {
      width: 100%;
    }

    &-title {
      width: 100%;
      position: relative;
      z-index: 1;
      font-family: Syne, sans-serif;
      font-size: 50px;
      font-weight: 700;
      background: linear-gradient(90deg, #04347D 0%, #2B3044 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &-block {
      margin-top: 20px;
      width: 100%;
      position: relative;
      padding-block: 30px 50px;
      background-image: url(@images/productLikeBg.png);
      background-repeat: no-repeat;
      background-size: cover;
    }

    &-bg {
      position: absolute;
      bottom: 0;
      width: 100%;
    }

    &-swiper {
      width: 100%;
      padding-bottom: 50px;

      &-slide {
        display: grid;
        place-items: center;
      }
    }
  }
}

.tag1 {
  background-color: #FE855F;
}
.tag2 {
  background-color: #5F9FFE;
}
.tag3 {
  background-color: #FED15F;
}

@media (max-width: 1680px) {
  .product {
    &__top {
      &-image {
        width: 450px;
        height: 300px;
      }
    }
  }
}

@media (max-width: 1250px) {
  .product {
    &__top {
      &-inner {
        padding-top: 25px;
        flex-direction: column-reverse;
        align-items: center;
      }

      &-left {
        align-self: flex-start;
      }
    }
  }
}

@media (max-width: 700px) {
  .product {
    &__top {
      padding-top: 150px;

      &-title {
        font-size: 36px;
      }

      &-desc {
        width: 100%;
      }

      &-block {
        flex-direction: column;
        align-items: flex-start;
        gap: 25px;
      }
    }
  }
}

@media (max-width: 500px) {
  .product {
    &__top {
      &-inner {
        & div {
          width: 100%;
        }
      }

      &-image {
        width: 100%;
      }
    }
  }
}
</style>